export default [
  "width",
  "height",
  "box-sizing",
  "display",
  "align-items",
  "justify-content",
  "font-size",
  "gap",
  "color",
  "background",
  "background-color",
  "font",
  "font-family",
  "fill",
  "stroke",
  "stroke-width",
  "margin",
  "padding",
  "padding-left",
  "padding-top",
  "padding-bottom",
  "padding-right",
  "flex-direction",
  "filter",
  "position",
  "top",
  "left",
  "bottom",
  "right",
  "content",
  "line-height",
  "text-decoration",
  "border-radius",
  "opacity",
  "border-right",
  "border-left",
  "border-width",
  "border-style",
  "border-color",
  "margin-right",
  "margin-left",
  "margin-top",
  "margin-bottom",
  "white-space",
  "overflow",
  "text-overflow",
  "font-weight",
  "min-width",
  "min-height",
  "transform",
  "z-index",
  "flex",
  "border-width",
  "text-wrap",
  "word-break",
  "vertical-align",
  "aspect-ratio",
  "object-fit",
];
